export default __webpack_public_path__ + "static/flag-nl-5ec0564487d9d69a1cfb363b886ff3f0.svg";